import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Returns a function that navigates back in browser history if available,
 * or falls back to a specified route if the user landed directly on the page.
 */
export function useGoBack(fallback: string) {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    // location.key is 'default' when the page is the first entry (direct access / bookmark)
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };
}
